import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import NewsContext from '../../context/news-context';
import Head from '../Head/index';
import StyledSelect from '../StyledSelect/index';
import { SignUpDiv,Container, Heading, Input, Label, SubmitButton } from './style';


const SignUp = () => {
    const [ location, setLocation ] = useState('New York City');
    const { setUser } = useContext(NewsContext);

    const history = useHistory();

    useEffect(() => {
        setUser({});
    }, []);

    const handleSignUp = (e) => {
        e.preventDefault();
        const name = e.target.username.value.trim();
        const email = e.target.email.value.trim();
        const password = e.target.password.value.trim();
        
        if(name && email && password && location) {
            setUser({
                name,
                email,
                location
            });

            history.push('/home');
        }
    }

    const handleOption = (option) => {
        setLocation(option);
    }

    return (
        <SignUpDiv>
            <Container>
                <Heading>
                    <h1>Create Account</h1>
                    <span>Sign up to get started!</span>
                </Heading>

                <form onSubmit={ handleSignUp }>
                    <Label htmlFor="username">Full Name</Label>
                    <Input type="text" id="username" placeholder="Enter your name..." required/>

                    <Label htmlFor="email">Email id</Label>
                    <Input type="email" id="email" placeholder="Enter email..."/>
                    <StyledSelect onChange={handleOption} label="Location"/>
                    <Label htmlFor="password">Password</Label>
                    <Input type="password" id="password" required placeholder="Enter password..."/>
                    <SubmitButton type="submit">Submit</SubmitButton>
                </form>
            </Container>
        </SignUpDiv>
    )   
}

export default SignUp;